export default __webpack_public_path__ + "static/media/23.3f8f2321.png";